module.exports = __webpack_public_path__ + "static/img/scene.0b83c5d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scene.gif
// module id = qEn6
// module chunks = 4